import api from './api';
import types from './mutation-types';

export default {
	selectProgress_: ({ commit, state }, params) => {
		const res = api.selectProgress(params);
		return res;
	}
};
